<template>
    <div class="about-page">
        <header class="top-nav">
            <button type="button" class="back-btn" @click="$router.back()">
                <van-icon name="arrow-left" />
            </button>
            <div class="nav-title">业务须知</div>
        </header>

        <main class="page-content">
            <section class="intro-card">
                <div class="intro-copy">
                    <span class="intro-tag">NOTICE</span>
                    <h1>平台业务说明</h1>
                    <p>查看平台规则、服务条款、隐私政策和其他业务说明内容，帮助你更清楚了解平台使用规范。</p>
                </div>
                <div class="intro-badge">
                    <van-icon name="description" />
                </div>
            </section>

            <section class="grid-panel">
                <router-link
                    v-for="(v, k) in data.list || []"
                    :key="v.id || k"
                    :to="'about/' + v.id"
                    class="grid-item"
                >
                    <div class="icon-wrap">
                        <img :src="getIcon(k)" :alt="v.title">
                    </div>
                    <span class="item-text">{{ v.title }}</span>
                </router-link>
            </section>
        </main>
    </div>
</template>

<script>
import Vue from "vue";
import { Icon } from "vant";
import Fetch from "../../utils/fetch";

Vue.use(Icon);

export default {
    name: "about",
    data() {
        return {
            data: {},
            iconMap: Array.from({ length: 14 }, (_, index) => require(`../images/about/icon${index}.png`)),
            appOriginalStyles: null,
            bodyOriginalBackground: "",
        };
    },
    created() {
        this.$parent.footer("user", false);
    },
    mounted() {
        this.applyFullScreenLayout();
        this.start();
    },
    beforeDestroy() {
        this.restoreFullScreenLayout();
    },
    methods: {
        applyFullScreenLayout() {
            const app = document.getElementById("app");
            if (!app) {
                return;
            }
            this.appOriginalStyles = {
                maxWidth: app.style.maxWidth,
                width: app.style.width,
                margin: app.style.margin,
                backgroundColor: app.style.backgroundColor,
                paddingBottom: app.style.paddingBottom,
            };
            this.bodyOriginalBackground = document.body.style.background;
            app.style.maxWidth = "100%";
            app.style.width = "100%";
            app.style.margin = "0";
            app.style.backgroundColor = "#000000";
            app.style.paddingBottom = "0";
            document.body.style.background = "#000000";
        },
        restoreFullScreenLayout() {
            const app = document.getElementById("app");
            if (app && this.appOriginalStyles) {
                app.style.maxWidth = this.appOriginalStyles.maxWidth || "";
                app.style.width = this.appOriginalStyles.width || "";
                app.style.margin = this.appOriginalStyles.margin || "";
                app.style.backgroundColor = this.appOriginalStyles.backgroundColor || "";
                app.style.paddingBottom = this.appOriginalStyles.paddingBottom || "";
            }
            document.body.style.background = this.bodyOriginalBackground || "";
        },
        start() {
            Fetch("/index/about").then((r) => {
                this.data = r.data || {};
            });
        },
        getIcon(index) {
            return this.iconMap[index % this.iconMap.length];
        },
    },
};
</script>

<style lang="less" scoped>
.about-page {
    min-height: 100vh;
    background:
        radial-gradient(circle at top right, rgba(33, 86, 255, 0.22), transparent 28%),
        linear-gradient(180deg, #020612 0%, #000000 52%, #000000 100%);
    color: #fff;
}

.top-nav {
    position: sticky;
    top: 0;
    z-index: 50;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 56px;
    padding: 0 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    background: rgba(0, 0, 0, 0.88);
    backdrop-filter: blur(12px);
}

.back-btn {
    position: absolute;
    left: 16px;
    top: 50%;
    width: 28px;
    height: 28px;
    margin-top: -14px;
    border: 0;
    background: transparent;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}

.back-btn .van-icon {
    font-size: 22px;
}

.nav-title {
    font-size: 18px;
    font-weight: 700;
}

.page-content {
    width: 100%;
    max-width: 430px;
    margin: 0 auto;
    padding: 24px 14px 30px;
    box-sizing: border-box;
}

.intro-card,
.grid-panel {
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 18px;
    background: rgba(6, 18, 52, 0.62);
    box-shadow: inset 0 0 0 1px rgba(45, 91, 255, 0.08);
    backdrop-filter: blur(12px);
}

.intro-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 22px 18px;
    margin-bottom: 18px;
}

.intro-copy {
    flex: 1;
    min-width: 0;
}

.intro-tag {
    display: inline-block;
    margin-bottom: 10px;
    color: #6c7cff;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 2px;
}

.intro-copy h1 {
    margin: 0 0 8px;
    font-size: 28px;
    font-weight: 800;
    line-height: 1.15;
    color: #fff;
}

.intro-copy p {
    margin: 0;
    color: rgba(255, 255, 255, 0.58);
    font-size: 12px;
    line-height: 1.8;
}

.intro-badge {
    width: 72px;
    height: 72px;
    border-radius: 20px;
    background: rgba(45, 91, 255, 0.12);
    box-shadow: 0 0 24px rgba(45, 91, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.intro-badge .van-icon {
    font-size: 34px;
    color: #2d5bff;
}

.grid-panel {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
    padding: 16px;
}

.grid-item {
    min-height: 122px;
    padding: 14px 10px 12px;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.02);
    border: 1px solid rgba(45, 91, 255, 0.18);
    color: #fff;
    text-decoration: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
}

.icon-wrap {
    width: 54px;
    height: 54px;
    border-radius: 16px;
    background: linear-gradient(180deg, rgba(15, 29, 78, 0.96), rgba(5, 14, 42, 0.96));
    box-shadow: 0 0 18px rgba(45, 91, 255, 0.18);
    display: flex;
    align-items: center;
    justify-content: center;
}

.icon-wrap img {
    width: 30px;
    height: 30px;
    object-fit: contain;
}

.item-text {
    width: 100%;
    text-align: center;
    color: #fff;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.45;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}
</style>
